/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { adminOpenRouterKeysDisableKey } from "../funcs/adminOpenRouterKeysDisableKey.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AdminOpenRouterKey } from "../models/components/adminopenrouterkey.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DisableAdminOpenRouterKeyRequest,
  DisableAdminOpenRouterKeySecurity,
} from "../models/operations/disableadminopenrouterkey.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DisableAdminOpenRouterKeyMutationVariables = {
  request: DisableAdminOpenRouterKeyRequest;
  security?: DisableAdminOpenRouterKeySecurity | undefined;
  options?: RequestOptions;
};

export type DisableAdminOpenRouterKeyMutationData = AdminOpenRouterKey;

export type DisableAdminOpenRouterKeyMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * disableKey adminOpenRouterKeys
 *
 * @remarks
 * Lock down an organization's platform OpenRouter key, upstream and locally. Requires platform admin.
 */
export function useDisableAdminOpenRouterKeyMutation(
  options?: MutationHookOptions<
    DisableAdminOpenRouterKeyMutationData,
    DisableAdminOpenRouterKeyMutationError,
    DisableAdminOpenRouterKeyMutationVariables
  >,
): UseMutationResult<
  DisableAdminOpenRouterKeyMutationData,
  DisableAdminOpenRouterKeyMutationError,
  DisableAdminOpenRouterKeyMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDisableAdminOpenRouterKeyMutation(client, options),
    ...options,
  });
}

export function mutationKeyDisableAdminOpenRouterKey(): MutationKey {
  return ["@gram/client", "adminOpenRouterKeys", "disableKey"];
}

export function buildDisableAdminOpenRouterKeyMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DisableAdminOpenRouterKeyMutationVariables,
  ) => Promise<DisableAdminOpenRouterKeyMutationData>;
} {
  return {
    mutationKey: mutationKeyDisableAdminOpenRouterKey(),
    mutationFn: function disableAdminOpenRouterKeyMutationFn({
      request,
      security,
      options,
    }): Promise<DisableAdminOpenRouterKeyMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(adminOpenRouterKeysDisableKey(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
